<div class="c4g-select-option"
     (click)="select($event)"
     [class.selected]="isSelected">
  <ng-content></ng-content>
</div>
